import { omit, clone } from 'ramda';

import { getInitialState } from '@/store/state';

import { deepFreeze } from '@/utils/common';

import { types } from '@/store/types';

export const mutations = {
  [types.mutations.RESET_STORE](state) {
    Object.assign(state, getInitialState());
  },

  [types.mutations.SET_TOKEN](state, token) {
    state[types.state.TOKEN] = token;
  },

  [types.mutations.SET_HASHED_DATA_ID](state, hashedDataId) {
    state[types.state.HASHED_DATA_ID] = hashedDataId;
  },

  [types.mutations.SET_INITIAL_PAGE_DATA](state, initialPageData) {
    state[types.state.INITIAL_PAGE_DATA] = initialPageData;
  },

  [types.mutations.SET_PATIENT_SKIN_DATA](state, patientSkinData) {
    state[types.state.PATIENT_SKIN_DATA] = patientSkinData;
  },

  [types.mutations.SET_SERUM_INCI_LISTS](state, serumInciLists) {
    state[types.state.SERUM_INCI_LISTS] = serumInciLists;
  },

  [types.mutations.SET_DYSFUNCTIONS_DATA](state, dysfunctionsData) {
    state[types.state.DYSFUNCTIONS_DATA] = dysfunctionsData;
  },

  [types.mutations.SET_TREATMENT_DATA](state, treatmentData) {
    state[types.state.TREATMENT_DATA] = deepFreeze(clone(treatmentData));
  },

  [types.mutations.SET_EYE_CONTOUR_SERUM_GENERIC_FORMULAS_LIST](state, formulasList) {
    state[types.state.EYE_CONTOUR_SERUM_GENERIC_FORMULAS_LIST] = formulasList;
  },

  [types.mutations.SET_RECOMMENDED_PRODUCT_NAMES](state, recommendedProducts) {
    state[types.state.RECOMMENDED_PRODUCT_NAMES] = recommendedProducts;
  },

  [types.mutations.SET_PRICES](state, prices) {
    state[types.state.PRICES] = prices;
  },

  [types.mutations.SET_DELIVERY_DATA](state, deliveryData) {
    // TODO (UNK-4433): investigate the possibility to remove the field on a back-end side
    state[types.state.DELIVERY_DATA] = omit(['deliverTo'], deliveryData);
  },

  [types.mutations.UPDATE_DELIVERY_TYPE](state, deliveryType) {
    state[types.state.DELIVERY_TYPE] = deliveryType;
  },

  [types.mutations.SET_STOCK](state, stock) {
    state[types.state.STOCK] = stock;
  },

  [types.mutations.SET_LOCALE](state, locale) {
    state[types.state.LOCALE] = locale;
  },

  [types.mutations.UPDATE_IS_LOADING_STATUS](state, isLoading) {
    state[types.state.IS_LOADING] = isLoading;
  },

  [types.mutations.SET_DOCTOR_SLUG](state, doctorSlug) {
    state[types.state.DOCTOR_SLUG] = doctorSlug;
  },

  /* CART */

  [types.mutations.TOGGLE_OPEN_CART](state) {
    state[types.state.IS_CART_OPEN] = !state.isCartOpen;
  },

  [types.mutations.UPDATE_PROMO_CODE_DATA](state, promoCodeData) {
    state[types.state.PROMO_CODE_DATA] = promoCodeData;
  },

  [types.mutations.SET_AVAILABLE_DELIVERY_COUNTRIES](state, countries) {
    state[types.state.AVAILABLE_DELIVERY_COUNTRIES] = countries.map(country =>
      country.toLowerCase()
    );
  },

  [types.mutations.SET_IS_CART_OPEN](state, isOpen) {
    state[types.state.IS_CART_OPEN] = isOpen;
  },

  [types.mutations.EMPTY_CART](state) {
    state[types.state.CART] = [];
  },

  [types.mutations.SET_SELECTED_EYE_SERUM_GENERIC_FORMULA_ID](state, formulaId) {
    state[types.state.SELECTED_EYE_SERUM_GENERIC_FORMULA_ID] = formulaId;
  },

  [types.mutations.SET_CART](state, cart) {
    state[types.state.CART] = cart;
  },

  [types.mutations.SET_TRUSTPILOT_DATA](state, trustpilotData) {
    state[types.state.TRUSTPILOT_DATA] = trustpilotData;
  },

  [types.mutations.SET_TRUSTPILOT_REVIEWS](state, trustpilotReviews) {
    state[types.state.TRUSTPILOT_REVIEWS] = trustpilotReviews;
  }
};
